export default "__VITE_ASSET__3b10d051__"